import { CSSProperties } from "@material-ui/core/styles/withStyles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const avatarWidth = 75;

export const label: CSSProperties = {
  color: colors.blueDusk.standard,
  fontWeight: "bold",
  fontSize: 20,
  margin: "-3px auto 0 40px",
};

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
};

export const loading: CSSProperties = {
  minHeight: 200,
};

export const title: CSSProperties = {
  marginTop: spacing.std,
  color: colors.blueDusk.standard,
  fontSize: 20,
  overflowWrap: "anywhere",
};

export const email: CSSProperties = {
  marginBottom: spacing.std,
  fontSize: size.md,
  lineHeight: 1.4,
  color: greys.slate,
  overflowWrap: "anywhere",
};

export const btnContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-around",
  alignItems: "center",
  width: 250,
  marginTop: 15,
};

export const btnStyle: CSSProperties = {
  background: greys.paleGrey,
};

export const btnActiveStyle: CSSProperties = {
  background: greys.cloudyBlue,
};

export const btnDisabledStyle: CSSProperties = {
  background: greys.palePaleGrey,
  color: greys.blueGrey,
};

export const btnLabel: CSSProperties = {
  fontSize: size.sm,
};

export const joinLabel: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontSize: 12,
  color: greys.slate,
};

export const logo = {
  size: 14,
  fill: colors.blueDusk.standard,
};
